<template>
  <div class="w-full">
    <SparkInput
      name="owner"
      label="Part Owner"
      v-model="owner"
      placeholder="Enter part owner"
    />
    <div
      v-if="owner"
      class="text-11 text-primary-600 cursor-pointer hover:text-primary-700 mt-2 text-right"
      @click="clear()"
    >
      Clear
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import SparkInput from '@/components/SparkComponents/SparkInput.vue';

export default {
  name: 'PartOwnerFilter',

  components: {
    SparkInput,
  },

  props: {
    reset: { type: Number, required: true },
    component: { type: String, required: true },
    label: { type: String, required: true },
  },

  emits: ['selected'],

  data() {
    return {
      owner: '',
    };
  },

  computed: {
    ...mapState(['partLibraryFilters']),
  },

  watch: {
    owner(newVal) {
      this.$emit('selected', { owner: newVal });
    },

    reset: {
      handler() {
        if (this.reset) {
          this.remove();
        }
      },
    },
  },

  mounted() {
    const filter = JSON.parse(sessionStorage.getItem('libraryFilter'));
    const ownParts = filter?.owner;
    if (ownParts) {
      this.owner = ownParts;
    }
  },

  methods: {
    ...mapMutations(['resetFilter', 'disablePartLibraryFilter']),

    clear() {
      this.owner = '';
      this.resetFilter({ owner: 'owner' });
    },

    remove() {
      this.disablePartLibraryFilter({
        [this.label]: this.component,
      });
      this.clear();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
